export default __webpack_public_path__ + "static/logoheader-338bf6f59292683409b3064c8957c4d3.jpg";